import confetti from "canvas-confetti"

export default ({ duration } = {}) => ({

  init() {
    const startConfetti = () => {
      const timeDuration = duration || 4 * 1000
      const animationEnd = Date.now() + timeDuration
      let skew = 1

      const colors = [
        "#FC9E1CBF",
        "#755FFE73",
        "#9DED1AE5",
        "#FFED36E5",
        "#9AF5FCE5",
        "#FF21FB",
        "#F54721",
        "#480CA7",
      ]

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      // Interval between bursts
      const interval = 150
      let previousBurstTime = 0
      let firstBurst = true

      // Confetti API docs:
      // https://github.com/catdad/canvas-confetti#readme
      function frame(now) {
        const timeLeft = animationEnd - Date.now()
        if (timeLeft <= 0) return

        // Burst only if enough time has passed
        // to make it look more natural and festive
        if (now - previousBurstTime > interval) {
          previousBurstTime = now
          const ticks = Math.max(200, 500 * (timeLeft / timeDuration))
          skew = Math.max(0.8, skew - 0.001)

          // Make first burst more intense for better look and natural feel
          if (firstBurst) {
            confetti({
              particleCount: 800,
              spread: 360,
              startVelocity: 40,
              origin: { x: 0.5, y: 0.5 },
              colors: colors,
              gravity: 0.5,
              scalar: 1,
            })

            firstBurst = false
          } else {
            confetti({
              particleCount: Math.floor(randomInRange(5, 15)),
              startVelocity: 25,
              ticks,
              origin: {
                x: Math.random(),
                y: (Math.random() * skew) - 0.2
              },
              colors: Array.from({ length: 5 }, () =>
                colors[Math.floor(Math.random() * colors.length)]
              ),
              gravity: randomInRange(0.4, 0.6),
              scalar: randomInRange(0.6, 1.2),
              drift: randomInRange(-0.4, 0.4)
            })
          }
        }

        requestAnimationFrame(frame)
      }

      requestAnimationFrame(frame)
    }

    startConfetti()

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        startConfetti()
      }
    })
  }
})
